export default "__VITE_ASSET__fVILpOaE__"